import { render, staticRenderFns } from "./CategoryCreate.vue?vue&type=template&id=3a6c6043&scoped=true"
import script from "./CategoryCreate.vue?vue&type=script&lang=js"
export * from "./CategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6c6043",
  null
  
)

export default component.exports